var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showAlert)?_c('div',{staticClass:"border-l-4",style:(_vm.discountWarningAccentColor)},[_c('p',{staticClass:"ml-2 text-sm",style:(_vm.discountWarningColor)},[_vm._v(_vm._s(_vm.value))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }